import React, { type JSX } from "react";
import { BeakerIcon } from "@heroicons/react/24/outline";

interface SidebarFooterProps {
  isCollapsed: boolean;
  onViewInAdmin: () => void;
}

/** Admin/auditing button pinned to the bottom of the sidebar. */
export default function SidebarFooter({
  isCollapsed,
  onViewInAdmin,
}: SidebarFooterProps): JSX.Element {
  return (
    <div className="px-4 py-4 border-t border-gray-200 flex-shrink-0">
      {isCollapsed ? (
        <button
          onClick={onViewInAdmin}
          className="w-full flex items-center justify-center p-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors duration-200"
          aria-label="View in Admin"
          title="View conversation in Admin"
        >
          <BeakerIcon className="h-5 w-5 text-gray-600" />
        </button>
      ) : (
        <button
          onClick={onViewInAdmin}
          className="w-full flex items-center gap-2 px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-lg transition-colors duration-200"
        >
          <BeakerIcon className="h-5 w-5 text-gray-600" />
          <span>View in Admin</span>
        </button>
      )}
    </div>
  );
}
